import { ChevronDown, Package } from "lucide-react";
import { purchaseRestoration } from "@/lib/purchase-restoration";

export function PurchaseHistory({ ids }: { ids: string[] }) {
  const { entries } = purchaseRestoration(ids);
  return <details className="pw-detail-section pw-purchase-history">
    <summary>
      <h3>Purchase history</h3>
      <span className="pw-caption">{ids.length.toLocaleString()} total purchase{ids.length === 1 ? "" : "s"}</span>
      <ChevronDown size={16} aria-hidden="true" />
    </summary>
    <div className="pw-purchase-history-content">
      <p className="pw-caption pw-purchase-note">Products recorded in this save. This list does not establish store revenue or refund status.</p>
      {entries.length ? <div className="pw-item-list">{entries.map(entry => <div className="pw-item-row" key={entry.id}>
        <span className="pw-item-icon"><Package size={18} aria-hidden="true" /></span>
        <div><strong>{entry.id}</strong><small>{entry.issue ?? entry.summary}</small></div>
        <span>×{entry.amount.toLocaleString()}</span>
      </div>)}</div> : <p className="pw-caption">No purchased products recorded.</p>}
    </div>
  </details>;
}
